'use strict';
window.theme = window.theme || {};
// ---------------------------------------------------------------------------------------
// Multi Level Drowpdown Menu Start
$(function () {
    $(".dropdown-menu > li > a.dropdown-toggle").on("click", function (e) {
        var current = $(this).next();
        var grandparent = $(this).parent().parent();
        if ($(this).hasClass('left-caret') || $(this).hasClass('right-caret'))
            $(this).toggleClass('right-caret left-caret');
        grandparent.find('.left-caret').not(this).toggleClass('right-caret left-caret');
        grandparent.find(".sub-menu:visible").not(current).hide();
        current.toggle();
        e.stopPropagation();
    });
    $(".dropdown-menu > li > a:not(.dropdown-toggle)").on("click", function () {
        var root = $(this).closest('.dropdown');
        root.find('.left-caret').toggleClass('right-caret left-caret');
        root.find('.sub-menu:visible').hide();
    });
});
// Multi Level Drowpdown Menu End
// ---------------------------------------------------------------------------------------

// ---------------------------------------------------------------------------------------
// Mega Drowpdown Menu Start
jQuery(document).ready(function () {
    if (window.matchMedia('(min-width: 768px)').matches) {
        $(".dropdown").hover(
                function () {
                    $('.dropdown-menu', this).stop(true, true).slideDown("fast");
                },
                function () {
                    $('.dropdown-menu', this).stop(true, true).slideUp("fast");
                }
        );
        // SUBSCRIBE NEWSLETTER
        var check  = localStorage.getItem("newsletter");
         check = parseInt(check);
         console.log(check);
        if(isNaN(check) || check < 3){
            check = isNaN(check) ? check = 1 : check = check+1;
            $(".subscribe-me").subscribeBetter({
                trigger: "onload",
                delay: 5000
            });
            localStorage.setItem("newsletter", check);
        }
        
    }

    if (window.matchMedia('(max-width: 767px)').matches) {
        $(".mega-dropdown").hover(
                function () {
                    $('.dropdown-menu', this).stop(true, true).slideDown("fast");
                },
                function () {
                    $('.dropdown-menu', this).stop(true, true).slideUp("fast");
                }
        );
    }

});

// Mega Drowpdown Menu End
// ---------------------------------------------------------------------------------------



jQuery(document).ready(function () {

    // Preloader
    $(window).bind("load", function () {
        $('#preloader').delay(1000).fadeOut(200);

    });

    var interval = null;

    interval = setInterval(function () {
        if ($("body:has(#preloader)")) {
            var babyclass = document.getElementsByClassName("baby");
            if (babyclass.length) {
                babyclass[0].classList.toggle('down');
            }
        }
    }, 500);
    $('body').on('click',".product-thumbnails li",function(event) {
        /* Act on the event */
        $(this).siblings('li').removeClass('active');
        $(this).addClass('active');
    });
    // Sticky Header
    $(window).scroll(function () {
        if (window.matchMedia('(min-width: 767px)').matches) {
            if (!(jQuery('body > main ').hasClass('header-style-wrap'))) {
                if ($(this).scrollTop() > 1) {
                    $('.header-wrapper').addClass("sticky-header");
                }
                else {
                    $('.header-wrapper').removeClass("sticky-header");
                }
            }
        }
    });


    // ---------------------------------------------------------------------------------------
    // Scroll To Top Start

    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $('.to-top').fadeIn();
        } else {
            $('.to-top').fadeOut();
        }
    });
    //Click event to scroll to top
    $('.to-top').click(function () {
        $('html, body').animate({scrollTop: 0}, 800);
        return false;
    });

    //Scroll To Top End
    // ---------------------------------------------------------------------------------------


    // ---------------------------------------------------------------------------------------
    // Product Slider Start

    jQuery(".product-slider.related-product").owlCarousel({
        autoPlay: true, //Set AutoPlay to 3 seconds
        items: 3,
        itemsDesktop: [1199, 3],
        itemsTablet: [1024, 2],
        itemsTabletSmall: [768, 2],
        itemsMobile: [480, 1]
    });
    jQuery(".verticle-tabination .product-slider").owlCarousel({
        autoPlay: true, //Set AutoPlay to 3 seconds
        items: 3,
        itemsDesktop: [1199, 3],
        itemsTablet: [1024, 3],
        itemsTabletSmall: [767, 2],
        itemsMobile: [480, 1]
    });
    jQuery(".product-slider").owlCarousel({
        autoPlay: true, //Set AutoPlay to 3 seconds
        items: 4,
        itemsDesktop: [1199, 4],
        itemsTablet: [1024, 3],
        itemsTabletSmall: [767, 2],
        itemsMobile: [480, 1]
    });

    jQuery(".product-slide.next").click(function () {
        jQuery(".product-slider").trigger('owl.next');
    });
    jQuery(".product-slide.prev").click(function () {
        jQuery(".product-slider").trigger('owl.prev');
    });
    // Product Slider End
    // ---------------------------------------------------------------------------------------


    // ---------------------------------------------------------------------------------------
    // Top Rated Slider Start
    jQuery(".tea-column-carousel").each(function(index, el) {
        var $carousel = $(this).owlCarousel({
            autoPlay: true, //Set AutoPlay to 3 seconds
            items: 1,
            itemsDesktop: [1199, 1],
            itemsTablet: [1024, 1],
            itemsTabletSmall: [767, 2],
            itemsMobile: [480, 1]
        });
        $(this).prev('.row').find('.next').click(function () {
            $carousel.trigger('owl.next');
        });
        $(this).prev('.row').find('.prev').click(function () {
            $carousel.trigger('owl.prev');
        });
    });
     

    // ---------------------------------------------------------------------------------------
    // Brands Slider Start
    jQuery("#brands-carousel-slider").owlCarousel({
        autoPlay: true, //Set AutoPlay to 3 seconds
        items: 7,
        itemsDesktop: [1199, 7],
        itemsDesktopSmall: [1024, 6],
        itemsTablet: [991, 4],
        itemsTabletSmall: [767, 3],
        itemsMobile: [480, 2]
    });
    jQuery(".brands-slider .next").click(function () {
        jQuery("#brands-carousel-slider").trigger('owl.next');
    });
    jQuery(".brands-slider .prev").click(function () {
        jQuery("#brands-carousel-slider").trigger('owl.prev');
    });
    // Brands Slider End
    // ---------------------------------------------------------------------------------------


    // ---------------------------------------------------------------------------------------
    // Testimonials Slider Start

    // Testimonials Slider End
    // ---------------------------------------------------------------------------------------


    // Cart Dorwpdown
    $('.cart-btn').click(function () {
        $('.cart-dropdown').slideToggle('fast');
    });

    // Who We Are Tabination
    $('#we-are-toggle').find('.we-are').click(function (e) {
        e.preventDefault();
        $(this).next().slideToggle('fast');
        $(this).find('.fa').toggleClass('fa-caret-right fa-caret-down');
        $(".we-are-content").not($(this).next()).slideUp('fast');
    });

    // ---------------------------------------------------------------------------------------
    // DateTimePicker Start
    $(".datetimepicker").datepicker();
    // DateTimePicker End
    // ---------------------------------------------------------------------------------------


    // ---------------------------------------------------------------------------------------
    // Checkout Massage Start

    $('#diff-address').click(function () {
        $('.form-delivery-different').toggle("slow");
    });
    $('#direct-transfer').click(function () {
        $('.direct-transfer-msg').show("slow");
        $('.cheque-transfer-msg').hide();
        $('.paypal-transfer-msg').hide();
    });

    $('#cheque-transfer').click(function () {
        $('.cheque-transfer-msg').show("slow");
        $('.direct-transfer-msg').hide();
        $('.paypal-transfer-msg').hide();
    });

    $('#paypal-transfer').click(function () {
        $('.paypal-transfer-msg').show("slow");
        $('.cheque-transfer-msg').hide();
        $('.direct-transfer-msg').hide();
    });

    // Checkout Massage End
    // ---------------------------------------------------------------------------------------
// ---------------------------------------------------------------------------------------
  // Countdown Start
  if ($().countdown) {
    var austDay = new Date();
    $('#dealCountdown2').each(function(){
      austDay = new Date($(this).data('y'), $(this).data('m') - 1, $(this).data('d'), $(this).data('h'), $(this).data('i'), $(this).data('s'));
      $(this).countdown({until: austDay});
    });
  }
  // Countdown End
  // ---------------------------------------------------------------------------------------




    // ---------------------------------------------------------------------------------------
    // Sidebar Filter Scroll Start
    if ($().slimScroll) {
        $('#pink-scroll').slimScroll({
            size: '3px',
            color: '#f37f8c',
            railOpacity: 1,
            alwaysVisible: true,
            railVisible: true,
            railColor: '#e4e4e4',
            opacity: '1',
            height: '215px'
        });
        $('#purple-scroll').slimScroll({
            size: '3px',
            color: '#9865eb',
            railOpacity: 1,
            alwaysVisible: true,
            railVisible: true,
            railColor: '#e4e4e4',
            opacity: '1',
            height: '215px'
        });
    }
    // Sidebar Filter Scroll End
    // ---------------------------------------------------------------------------------------

    $(".view-controler li").click(function(event) {
        /* Act on the event */
        $(this).siblings('li').removeClass('active');
        $(this).addClass('active');
        if($(this).data('view') == 'list'){
            $(".change-view-data").removeClass('product-grid-view').addClass('product-list-view');
        }else{
            $(".change-view-data").addClass('product-grid-view').removeClass('product-list-view');
        }
    });
    $('body').on('click',".buttons-add-minus .plus",function(event) {
        /* Act on the event */
        var input = $(this).prev('input'),
        val = parseInt(input.val());
        input.val(val+1);
    });
    $('body').on('click',".buttons-add-minus .minus",function(event) {
        /* Act on the event */
        var input = $(this).next('input'),
        val = parseInt(input.val());
        if(val > 1){
            input.val(val-1);
        }
    });
    var ReFeshCart = function(data,total){
        $(".tea-total-amount").html('<span class=money>'+Shopify.convertWithCurrency(total.total_price) + '</span>');
        $(".tea-total").html(total.item_count);
        $.get('/cart',{view:'html'}, function(data) {
            /*optional stuff to do after success */
            $(".header-cart tbody").html(data);
            Shopify.convertAll(".header-cart tbody span.money");
        });
    }
    $('body').on('click', ".ajax-add-to-cart", function(event) {
        event.preventDefault();
        /* Act on the event */
        var $pid = $(this).data('pid');
        Shopify.addItem($pid,1,function(data){
            
           Shopify.getCart(function(total){
                $(".tea-cart-image").attr('src',Shopify.resizeImage(data.image,"large"));
                $("#layer_cart_product_title").html(data.title);
                $("#layer_cart_product_quantity").html(data.quantity);
                $("#layer_cart_product_price").html(Shopify.convertWithCurrency(data.price));
                $(".ajax_cart_quantity").html(data.quantity);
                $(".ajax_block_cart_total").html(Shopify.convertWithCurrency(data.line_price));
                $("#cart-preview").modal({backdrop: 'static', keyboard: false});
             ReFeshCart(data,total);
           });
        });
    });
    $("body").on('click', '.quickview-add-to-cart,.single-add-to-cart', function(event) {
        event.preventDefault();
        /* Act on the event */
    var form = "single-form-cart";
    if($(this).hasClass('quickview-add-to-cart')){
        form = 'quickview-form';
    }
     Shopify.addItemFromForm(form,function(data){
        Shopify.getCart(function(total){
                $(".tea-cart-image").attr('src',Shopify.resizeImage(data.image,"large"));
                $("#layer_cart_product_title").html(data.title);
                $("#layer_cart_product_quantity").html(data.quantity);
                $("#layer_cart_product_price").html(Shopify.convertWithCurrency(data.price));
                $(".ajax_cart_quantity").html(data.quantity);
                $(".ajax_block_cart_total").html(Shopify.convertWithCurrency(data.line_price));
                $("#cart-preview").modal({backdrop: 'static', keyboard: false});
                $("#product-preview").modal('hide');
             ReFeshCart(data,total);

           });
     })
    });
    $("body").on('click', '.delete-line-item', function(event) {
        event.preventDefault(); 
        /* Act on the event */
        var id = $(this).data('cid');
        Shopify.removeItem(id,function(data){
            Shopify.getCart(function(total){
             ReFeshCart(data,total);
           });
        });
    });
    $("body").on('click', '.product-preview,.quickview', function(event) {
        event.preventDefault();
        /* Act on the event */
        var handle = $(this).data('handle');
        $.get('/products/'+handle,{view:'quickview'}, function(data) {
            /*optional stuff to do after success */
            $("#product-preview").modal('show');
            $("#product-fullwidth").html(data);
            $(".carousel-quickview").carousel({interval:false});
            Shopify.convertAll("#product-fullwidth span.money");
        });
    });
    $("body").on('click', '.login-to-use-wishlist', function(event) {
        event.preventDefault();
        /* Act on the event */
        $('#login-wishlist').modal('show');
    });    
    $("body").on('click', '.wishlist', function(event) {
        event.preventDefault();
        /* Act on the event */
            
            var $this = $(this);
            $this.next('form').submit(); //.serialize();
//             $.post('/contact', $form, function(data, textStatus, xhr) {
//                              /*optional stuff to do after success */
//                $('#login-wishlist').modal('show');
//                 $('#login-wishlist p').html('added successfully ');
//                 $this.removeClass('wishlist').addClass('added-wishlist').attr('href','/collections/wish-list');
//             });             
    });
  $(document).on('click', '.wishlist-remove', function(event) {
    event.preventDefault();
    /* Act on the event */
    var $this = $(this);
    $this.button('loading');
    setTimeout(function() {
      $this.button('reset');
    }, 4000);
    /* Remove product from wishlist*/
    var value = $(this).data('wid');
    $('.remove-value').val(value);
    var args = $('.contact-form').serialize();
    $.ajax({
      url: $('.contact-form').attr('action'),
      type: 'POST',
      dataType: 'html',
      data: args,
      success: function(data, status) {
        if (status == "success") {
          $("#tea-" + value).slideUp(600).remove();
         $('#login-wishlist').modal('show');
                $('#login-wishlist p').html('Removed successfully ');
        } else {
          $("#loading").fadeOut(1000);
        }
        
      }
    });
  });
    if($(".tea-block-filter").length){
        $("body").on('click', '.tea-submit-filter', function(event) {
            event.preventDefault();
            /* Act on the event */
            var form = $(this).closest('form');
            var str = '{"access_token":"'+Math.random().toString(36).replace(/[^a-z]+/g, '')+'"';
            form.find('select').each(function(index, el) {
                str +=',"'+$(this).attr('name')+'":"' + $(this).val()+'"';
            });
            str+='}';
             var collection = $(this).closest('form').data('collection');
             if(collection != ""){
                location.href='/collections/'+collection+'?filter='+str;
             }
        });
    }
  
  
  window.theme = theme || {};

theme.customerTemplates = (function() {

  function initEventListeners() {
    // Show reset password form
    $('#RecoverPassword').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });

    // Hide reset password form
    $('#HideRecoverPasswordLink').on('click', function(evt) {
      evt.preventDefault();
      toggleRecoverPasswordForm();
    });
  }

  /**
   *
   *  Show/Hide recover password form
   *
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *
   *  Show reset password success message
   *
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }

  /**
   *
   *  Show/hide customer address forms
   *
   */
  function customerAddressForm() {
    var $newAddressForm = $('#AddressNewForm');

    if (!$newAddressForm.length) {
      return;
    }

    // Initialize observers on address selectors, defined in shopify_common.js
    if (Shopify) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew'
      });
    }

    // Initialize each edit form's country/province selector
    $('.address-country-option').each(function() {
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });

    // Toggle new/edit address forms
    $('.address-new-toggle').on('click', function() {
      $newAddressForm.toggleClass('hide');
    });

    $('.address-edit-toggle').on('click', function() {
      var formId = $(this).data('form-id');
      $('#EditAddress_' + formId).toggleClass('hide');
    });

    $('.address-delete').on('click', function() {
      var $el = $(this);
      var formId = $el.data('form-id');
      var confirmMessage = $el.data('confirm-message');

      // eslint-disable-next-line no-alert
      if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
        Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
      }
    });
  }

  /**
   *
   *  Check URL for reset password hash
   *
   */
  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  return {
    init: function() {
      checkUrlHash();
      initEventListeners();
      resetPasswordSuccess();
      customerAddressForm();
    }
  };
})();

  theme.customerTemplates.init();
    function SectionReInit(){
        $(".selectpicker").each(function(index, el) {
            $(this).selectpicker($(this).data());
        });
            jQuery(".testimonials-slider").owlCarousel({
                autoPlay: true, //Set AutoPlay to 3 seconds
                items: 1,
                itemsDesktop: [1199, 1],
                itemsTablet: [1024, 1],
                itemsMobile: [768, 1]
            });
            jQuery(".testimonials-wrap .next").click(function () {
                jQuery(".testimonials-slider").trigger('owl.next');
            });
            jQuery(".testimonials-wrap .prev").click(function () {
                jQuery(".testimonials-slider").trigger('owl.prev');
            });
    }
    SectionReInit();
    $(document)
    .on('shopify:section:load', SectionReInit)
    .on('shopify:section:unload', SectionReInit)
    .on('shopify:section:select',SectionReInit)
    .on('shopify:section:deselect', SectionReInit)
    .on('shopify:block:select',SectionReInit)
    .on('shopify:block:deselect', SectionReInit);
 
	
  
  $('.address-edit-toggle').click(function(){
    var editAddressID = '#EditAddress_'+$(this).attr('data-form-id');
    //alert(editAddressID);
    $(editAddressID).toggleClass('tea-show');
  });
  
  $('.address-new-toggle').click(function(){
  	$('#AddressNewForm').toggleClass('tea-show');
  });
  	
});



// ---------------------------------------------------------------------------------------
